import {
    PieChart,
    Pie,
    Tooltip,
    Cell,
    Legend,
    ResponsiveContainer
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { FertilizerLegend, PieTooltip, fertilizerPieChartLabel } from '../utils/graph-utils';
import { fertilizerColors, legendHeight, legendIconSize, fertilizerLegendItems, outerRadius, responsiveContainerHeight } from '../constants/graph-constants';

/**
 * 
 * @param {Object} props 
 * @param {{category: string, total: number, type: string}} props.data Graph data from backend
 * @param {string} props.type
 * @param {string} props.group "Twee Jonge Gezellen"
 * @param {string} props.year "2024"
 * @param {string} props.unit The relevant unit.
 * @returns {JSX.Element} The facility's bar graph which displays an array of fertilizer items
 */
export default function FertilizerGroupPieChart({ data, type, year, companyName, unit }) {
    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {companyName} {year} Annual {type} Group Split
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <PieChart>
                    <Tooltip content={<PieTooltip unit={unit} />} />
                    <Legend content={<FertilizerLegend legendItems={fertilizerLegendItems} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    <Pie
                        data={data}
                        dataKey="total"
                        nameKey="category"
                        cx="50%"
                        cy="50%"
                        outerRadius={outerRadius}
                        labelLine={false}
                        label={fertilizerPieChartLabel}
                    >
                        {data?.map((entry, index) => (
                            <Cell key={index}
                                fill={fertilizerColors[entry.category] || '#ccc'}
                            />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
        </Box>
    )
}